const eventLanguage=s=>typeof s==='string'?s.replace(/Personal Events/g,'Events').replace(/Personal Event/g,'Event').replace(/personal events/g,'events').replace(/personal event/g,'event'):s;
export const slugify = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

function Blocks({ blocks }) {
  const out = [];
  let i = 0;
  while (i < blocks.length) {
    if (blocks[i].t === "li") {
      const items = [];
      while (i < blocks.length && blocks[i].t === "li") { items.push(blocks[i].text); i++; }
      out.push(
        <ul key={out.length} className="my-3 list-disc space-y-2 pl-6 text-bodygrey">
          {items.map((t, k) => <li key={k}>{eventLanguage(t)}</li>)}
        </ul>
      );
    } else {
      out.push(<p key={out.length} className="my-3 leading-relaxed text-bodygrey">{eventLanguage(blocks[i].text)}</p>);
      i++;
    }
  }
  return out;
}

export default function PolicyBody({ policy }) {
  return (
    <>
      {policy.sections.map((s, idx) => (
        <section key={idx} id={s.heading ? slugify(s.heading) : undefined} className="mb-8 scroll-mt-24">
          {s.heading && <h2 className="font-heading text-xl font-semibold text-navy md:text-2xl">{eventLanguage(s.heading)}</h2>}
          <Blocks blocks={s.blocks} />
        </section>
      ))}
    </>
  );
}

